

//货场模块相关 api
import request from "@/utils/request";
const baseService = "autoapp-default-server-recovery";


//货场模块 start
/**
 * @function  货场-获取列表
 */
export function getYardList(data) {
  return request({
    url: `${baseService}/api/goodsyard/pc/list`,
    method: "post",
    data
  });
}


/**
 * @function  货场-获取详情
 */
export function getYardInfo(id) {
  return request({
    url: `${baseService}/api/goodsyard/pc/detail/${id}`,
    method: "get",
  });
}

/**
 * @function  货场-编辑货场
 */
export function updateYard(data) {
  return request({
    url: `${baseService}/api/goodsyard/pc/update`,
    method: "post",
    data
  });
}


/**
 * @function  货场-导出
 */
export function exportList(data) {
  return request({
    url: `${baseService}/api/goodsyard/pc/exportList`,
    method: "post",
    data
  });
}



/**
 * @function  货场-删除
 */
export function delGoodsyard(id) {
  return request({
    url: `${baseService}/api/goodsyard/pc/delete/${id}`,
    method: "post",
  });
}

/**
 * @function  获取分公司列表
 */
export function getManagementList(data) {
  return request({
    url: `/autoapp-recovery-server-auth/api/tbl-partner-management/page`,
    method: "post",
    data
  });
}


/**
 * @function  获取竞企列表
 */
export function getCompetitorsList(data) {
  return request({
    url: `${baseService}/api/goodsyard/pc/competitorsList`,
    method: "get",
  });
}





// WEBPACK FOOTER //
// ./src/api/goodsYard.js